export class ErzeugungsanlageImportJob {
    public report?: string;
    public erzeugerTotal: number;
    public nrProcessedTransformations: number;
    public nrStoredErzeuger: number;
    public phase: number;
    public error?: boolean;
    public done?: boolean;
}

export const initialImportJob: ErzeugungsanlageImportJob = {
    erzeugerTotal: 0,
    nrProcessedTransformations: 0,
    nrStoredErzeuger: 0,
    phase: 10,
};
